import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from '@angular/router';
import {AlertPanelComponent, AlertPanelService} from "@amlCore/components";
import {DictionaryService, UserService} from "@amlCore/services";
import {DossierAccessEnum} from "@amlCore/enums";
import {AbstractControl, FormArray, FormControl, FormGroup} from "@angular/forms";
import {forkJoin, Subject} from "rxjs";
import {Utils} from "@amlCore/utils";
import {DetectTransaction} from "../../../models/detectTransaction.model";
import {finalize} from "rxjs/operators";
import {SettingsTransactionsService} from "../settingsTransactions.service";
import {ConfirmComponent} from "@amlCore/modals";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-detect-transaction-form",
  templateUrl: "./detectTransactionForm.component.html",
  styleUrls: ['./detectTransactionForm.component.scss']
})

export class DetectTransactionFormComponent implements OnInit, OnDestroy {
  @ViewChild("alertObjSave") alertObjToSave: AlertPanelComponent;

  private id: string; // уникальный идентификатор
  public detectData: DetectTransaction; // модель формы просмотра
  public isReadOnlyAccess = false;
  isLoaded = false; // Признак, что форма загружена
  disabled = false;
  submitted = false;
  /*справочники*/
  dictionary: { [name: string]: Array<any>; } = {
    participantTypes: this.dictSrv.getStaticData("participantType")
  };
  dictLoaded: boolean = false;
  isSaveForm = false; // Признак, что форма сохранена
  form: FormGroup;
  $destroy = new Subject();
  constructor(
    private route: ActivatedRoute,
    protected router: Router,
    protected alertPanelSrv: AlertPanelService,
    protected userSrv: UserService,
    protected dictSrv: DictionaryService,
    private readonly modalService: NgbModal,
    private service: SettingsTransactionsService) {

  }

  ngOnInit() {
    this.isReadOnlyAccess = this.userSrv.getAccess(DossierAccessEnum.TRANSACTIONSETTINGS).readOnly;
    this.loadRemoteData(['typeulfl', 'clientTrue', "type_money", "conditions", "qrefVo4936", "okv", "oksm"]);

    this.route.params.subscribe((params) => {
      this.id = params.id;
      this.loadDetectTransaction();
    });
  }

  loadRemoteData(types: Array<string>) {
    const russianRubCode = "810";
    const stateRubCurrency = "ПРИЗНАК РОССИЙСКОГО РУБЛЯ";
    const obList = types.map(type => this.dictSrv.getDictionaryData(type));
    forkJoin(obList).subscribe((data) => {
      types.forEach((type, index) => {
        if(type == 'typeulfl'){
          this.dictionary[type] = (data[index] || []).filter((item) => item.code != 0);
        }
        else if(type == 'okv'){
          this.dictionary[type] = (data[index] || []).filter((item) => {
            return ((item.iso_dig === russianRubCode && item.name !== stateRubCurrency) ||
              !Utils.dateNowIsAfter(item.cb_date));
          });
        } else {
          this.dictionary[type] = data[index];
        }
      });
      this.dictLoaded = true;
    });
  }

  ngOnDestroy(): void {
    this.$destroy.next();
    this.$destroy.complete();
  }

  /* Загрузка сценария */
  private loadDetectTransaction() {
    this.service.getDetectTransactionById(this.id).subscribe((data: DetectTransaction) => {
      this.updateForm(data, true);
    });
  }

  /* Сохранить изменения в сценарии */
  public saveDetectTransaction() {
    this.submitted = true;
    if(!this.form.valid){
      if(this.f('participantType').errors?.['required']
        ||this.f('clientType').errors?.['required']
        ||this.f('clientTrue').errors?.['required']
        ||this.f('currencyType').errors?.['required'] ){
        this.alertObjToSave.open(this.alertPanelSrv.getErrorMsg('Необходимо заполнить "Основные параметры"'));
      }
      return;
    }

    const editableData = Utils.clone(this.form.value);
    editableData.id = this.detectData.id;
    if(editableData.settings.some(s => "purpose" == this.service.getConditionType(s) && !s.value)){
      const modal = this.modalService.open(ConfirmComponent);
      modal.componentInstance.text ='Поиск операций без учета назначение платежа';
      modal.result.then(() => {
        this.doSave(editableData);
      }, () => {})
      return;
    }
    this.doSave(editableData);
  }

  private doSave(data: any){
    this.disabled = true;
    this.service.saveDetectTransaction(data).pipe(finalize(() => this.disabled = false))
      .subscribe((data) => {
        this.updateForm(data);
        this.form.markAsPristine();
        this.isSaveForm = true;
        this.alertObjToSave.open(this.alertPanelSrv.getSuccessMsg('Данные успешно сохранены'));
      });
  }

  updateForm(data?: DetectTransaction, isInit?: boolean): void{
    if(data){
      if(isInit){
        this.createForm(data);
      } else {
        this.form.patchValue(this.dataToModel(data));
      }
      this.detectData = data;
    }
    if(this.isReadOnlyAccess){
      this.form.disable();
    } else{
      this.form.enable();
    }
  }

  private createForm(data: DetectTransaction){
    this.form = this.service.createDetectTransactionForm(data);
  }

  getCodeName(code: string): string {
    return this.dictSrv.getDictNameByCode(code, this.dictionary.qrefVo4936);
  }

  dataToModel(data: DetectTransaction){
    return Utils.clone(data);
  }

  f(field: string): FormControl {
    return this.form.get(field) as FormControl;
  }

  fArray(field: string): FormArray {
    return this.form.get(field) as FormArray;
  }

  fGroup(control: AbstractControl): FormGroup {
    return control as FormGroup;
  }

  protected readonly FormGroup = FormGroup;
}
